import { render, staticRenderFns } from "./returnVisitedManager.vue?vue&type=template&id=06f15144&scoped=true&"
import script from "./returnVisitedManager.vue?vue&type=script&lang=ts&"
export * from "./returnVisitedManager.vue?vue&type=script&lang=ts&"
import style0 from "./returnVisitedManager.vue?vue&type=style&index=0&id=06f15144&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f15144",
  null
  
)

export default component.exports